module.exports = __webpack_public_path__ + "img/creador_header.561067ff.jpg";